/** Renter road rules shown on Booking Summary and Terms (KAN-197). */

export const ROAD_RULES = [
  {
    id: "no-smoking",
    title: "No smoking",
    detail: "$150 fine",
  },
  {
    id: "keep-tidy",
    title: "Keep tidy",
    detail: "$150 fine if unreasonably dirty",
  },
  {
    id: "refuel",
    title: "Refuel vehicle",
    detail: "Missing fuel may incur a fee",
  },
  {
    id: "no-off-roading",
    title: "No off-roading",
    detail: "Stay on paved / permitted roads",
  },
];

export function formatRoadRuleLine(rule) {
  if (!rule) return "";
  return rule.detail ? `${rule.title} — ${rule.detail}` : rule.title;
}
